import { Toast } from "../../CommonComponents";

export const internalPageError = (message: string) => {
  Toast({
    message,
    type: "error",
  });
};
